export const useLeftNavStore = defineStore('leftNav', () => {
  const isRailOpen = ref(false)
  const nav = ref([
    //{ to: '/', label: 'HOME', icon: 'mdi-home' },
    {
      to: '/inventory',
      label: 'INVENTORY',
      icon: '',
      groups: ['WEB_USER', 'WEB_ADMIN'],
      subItems: [
        { to: '/inventory/style', label: 'STYLE NUMBER', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/inventory/category', label: 'CATEGORY', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/inventory/sizeAndColor', label: 'SIZE AND COLOR', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/inventory/color', label: 'COLOR ONLY', groups: ['WEB_USER', 'WEB_ADMIN'] },
        {
          to: '/inventory/priceAndColorAndSize',
          label: 'PRICE RANGE, COLOR & SIZE',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        { to: '/inventory/barcode', label: 'BARCODE', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/inventory/colorAndSizeCharts', label: 'COLOR CARD & SIZE CHARTS', groups: ['WEB_USER', 'WEB_ADMIN'] },
        {
          to: '/inventory/style/list?type=OFFPRICE&categoryCode=ALL OFFPRICE MARCH 2026',
          label: 'ALL OFFPRICE MARCH 2026',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        {
          to: '/inventory/style/list?type=CATEGORY&categoryCode=FALL+2026',
          label: 'Homecoming and Short Prom Dresses - Fall 2026',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        {
          to: '/inventory/style/list?type=CATEGORY&categoryCode=FALL+2026+SIGNATURE+EVENING+DRESSES',
          label: 'Signature & Evening Dresses - Fall 2026',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        {
          to: '/inventory/style/list?type=CATEGORY&categoryCode=BRIDAL+OCCASION+PROMO',
          label: 'Bridal Occasion Promo',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        {
          to: '/inventory/style/list?type=CATEGORY&categoryCode=MOB+PROMO',
          label: 'MOB Promo',
          groups: ['WEB_USER', 'WEB_ADMIN']
        },
        {
          to: '/inventory/style/list?type=CATEGORY&categoryCode=EVENING/GUEST+PROMO',
          label: 'Evening/Guest Promo',
          groups: ['WEB_USER', 'WEB_ADMIN']
        }
      ]
    },
    {
      //to: '/',
      label: 'MY ACCOUNT',
      icon: '',
      groups: ['WEB_USER', 'WEB_ADMIN'],
      subItems: [
        { to: '/myorders', label: 'My Web Orders', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/statements', label: 'Statements', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/creditMemos', label: 'Credit Memo Status', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { to: '/openOrders', label: 'Open Order Status', groups: ['WEB_USER', 'WEB_ADMIN'] },
        { divider: true, action: 'showMyAccount', label: 'Manage My Account', groups: ['WEB_USER', 'WEB_ADMIN'] }
      ]
    },
    { to: '/tradeshows', label: 'TRADESHOWS', icon: '' },
    { to: '/lookbooks', label: 'LOOKBOOKS', icon: '' },
    {
      to: '/ra-support',
      label: 'RA SUPPORT',
      icon: '',
      groups: ['WEB_USER', 'WEB_ADMIN'],
      subItems: [
        { to: '/ra-support', label: 'RA REQUEST', groups: ['WEB_USER'] },
        { to: '/ra-support/list', label: 'RA STATUS', groups: ['WEB_USER', 'WEB_ADMIN'] }
      ]
    },
    { to: '/contact', label: 'CONTACT', icon: '' },
    {
      url: 'https://www.google.com/maps/place//data=!4m3!3m2!1s0x89c259ab956be00d:0xfcfd1647e6186f7d!12e1?source=g.page.m.ia._&laa=nmx-review-solicitation-ia2',
      label: 'REVIEW US',
      icon: ''
    },
    { url: 'https://www.jovani.com/', label: 'JOVANI.COM', icon: '' }
  ])

  const customUrlRules = [
    { to: '/ra-support/create', groups: ['WEB_USER'] },
    //{ to: '/cart', groups: ['WEB_USER'] },
    { to: '/checkout', groups: ['WEB_USER'] }
  ]
  // computed
  const flatMenus = computed(() => {
    const flatten = []

    for (const item of nav.value) {
      flatten.push({ to: item.to, groups: item.groups })

      addSubMenus(flatten, item)
    }
    //return flatten
    return [...flatten, ...customUrlRules]
  })

  const addSubMenus = (flatten, item) => {
    const subItems = getSubMenus(item)
    if (subItems.length === 0) return

    for (const subItem of subItems) {
      flatten.push({ to: subItem.to, groups: subItem.groups })

      addSubMenus(flatten, subItem)
    }
  }

  const getSubMenus = (item) => {
    if (!!item.subItems && item.subItems.length > 0) {
      return item.subItems
    }

    return []
  }

  const getParentMenus = (toPath) => {
    const parentMenus = []
    const parentPaths = []

    const paths = toPath.split('/').filter((path) => path !== '')

    while (paths.length > 1) {
      paths.pop()
      parentPaths.push(`/${paths.join('/')}`)
    }

    for (const parentPath of parentPaths) {
      const pathFind = flatMenus.value.find((m) => m.to === parentPath)
      if (pathFind) {
        parentMenus.push({ to: pathFind.to, groups: pathFind.groups })
      }
    }

    return parentMenus
  }

  const hasAccessToMenu = (toPath, userData) => {
    //console.log('hasAccessToMenu', toPath, userData.userGroup, flatMenus.value)
    const pathFind = flatMenus.value.find((m) => m.to === toPath)
    if (pathFind) {
      //console.log('hasAccessToMenu pathFind', pathFind)
      if (pathFind.groups && !pathFind.groups.includes(userData.userGroup)) {
        return false
      }
    }

    const parentMenus = getParentMenus(toPath)
    for (const parentMenu of parentMenus) {
      if (parentMenu.groups && !parentMenu.groups.includes(userData.userGroup)) {
        return false
      }
    }

    return true
  }

  return { isRailOpen, nav, hasAccessToMenu }
})
